import React, { useState } from 'react';
import { MAP_CONDITION_FROM_WATSON, SPECIAL_CONDITTIONS } from '../../../dto/DialogConditionDTO';
import Input from '../../@base/Input';
import Select from '../../@base/Select';
import SelectOption from '../../@base/SelectOption';
import Tooltip from '../../@base/Tooltip';
import {
  calculeWidth, allIntents, allEntities,
} from './DialogNodeCondition';

const isHidden = { style: { visibility: 'hidden' } };

/** Componente de tooltip para erros nas condições */
const ErrorNotification = (props) => (
  <>
    <span className="invalid-icon ">
      <i
        className="fa fa-exclamation-circle fa-sm"
        aria-hidden="true"
      />
    </span>
    <Tooltip place="right" error="true">
      <div>
        {`A ${props.condition.type}
          não existe. Você deve escolher outro valor`}
      </div>
    </Tooltip>
  </>
);

/** Representa uma parte da condição do dialogo */
const ConditionPart = (props) => {
  const part = props.condition[props.id];

  let options = null;
  let value = part;
  let placeholder = ' ';
  let width = null;
  let errorMessage = '';

  /**
   * Manipulador de mudanças em partes da condição
   *
   * Defini regras que alteram quais partes da condição estão
   * disponiveis para alteração de acordo com a parte que foi alterada
   */
  const onChangeConditionPartHandler = (valueChanged) => {
    if (valueChanged === '' || valueChanged === value) { return null; }

    const conditionChanged = {
      ...props.condition,
      [props.id]: valueChanged,
    };

    if (props.id === 'type') {
      conditionChanged.object = ' ';
      conditionChanged.logicalOperator = MAP_CONDITION_FROM_WATSON.existir;
      conditionChanged.comparedValue = null;
    } else if (props.id === 'object'
      && conditionChanged.type === MAP_CONDITION_FROM_WATSON.entity) {
      conditionChanged.logicalOperator = MAP_CONDITION_FROM_WATSON.existir;
      conditionChanged.comparedValue = null;
    } else if (props.id === 'logicalOperator') {
      conditionChanged.comparedValue = ' ';
    }

    props.setCondition(conditionChanged);
  };

  /** Tenta retornar um textInput para valueCompared
   *  se a parte for um  comparedValue e logicalOperator for menor que ou maior que  */
  const tryReturnInputText = () => {
    if (props.condition.logicalOperator === MAP_CONDITION_FROM_WATSON['<']
      || props.condition.logicalOperator === MAP_CONDITION_FROM_WATSON['>']) {
      const [comparedValueInput, setComparedValueInput] = useState(part);

      /** Manipulador de mudanças exclusivo para
      *  input text da parte ComparedValue */
      const onChangeComparedValue = (e) => {
        const valueChanged = e.target.value;
        setComparedValueInput(valueChanged);
      };

      const onBlurComparedValue = () => {
        props.setCondition({
          ...props.condition,
          comparedValue: comparedValueInput,
        });
      };

      value = comparedValueInput === ' ' ? '' : comparedValueInput;
      placeholder = 'Digite um valor';

      return (
        <Input
          width={value ? calculeWidth(value) : calculeWidth(placeholder)}
          placeholder={placeholder}
          value={value}
          onChange={onChangeComparedValue}
          onBlur={onBlurComparedValue}
        />
      );
    }

    return null;
  };

  /** A parte pode ser não ser renderizada a prop notRender */
  if (props.notRender) {
    return <div style={{ display: 'none' }} />;
  }

  /** Se a parte for da primeira condição ela é ocultada */
  if (props.firstCondition) {
    return <div {...isHidden} />;
  }

  switch (props.id) {
    case 'relationalOperator': {
      options = [MAP_CONDITION_FROM_WATSON['&&'], MAP_CONDITION_FROM_WATSON['||']];
      placeholder = 'e/ou';
      break;
    }
    case 'type': {
      options = [MAP_CONDITION_FROM_WATSON.intent, MAP_CONDITION_FROM_WATSON.entity];
      if (!props.slotCondition) {
        options.push(MAP_CONDITION_FROM_WATSON.special_condition);
      }
      width = calculeWidth(value);
      break;
    }
    case 'object': {
      if (props.condition.type === MAP_CONDITION_FROM_WATSON.intent) options = allIntents;
      else if (props.condition.type === MAP_CONDITION_FROM_WATSON.entity) options = allEntities;
      else options = SPECIAL_CONDITTIONS.map((c) => ({ name: c }));

      options = options.map((o) => o.name);

      width = calculeWidth(value);
      if (value === ' ') {
        placeholder = `Selecione uma ${props.condition.type}`;
        width = calculeWidth(placeholder);
      } else {
        const valueNotExist = !options.includes(value);
        if (valueNotExist) {
          placeholder = `${value}`;
          width = calculeWidth(placeholder);
          errorMessage = 'Não existe';
        }
      }

      break;
    }
    case 'logicalOperator': {
      /** Se a parte for logicalOperator e referente a uma intenção ou condição especial de
       *  é permitido apenas o operador existir, portanto
       *  e exibido um rotulo fixo com conteudo exibir */
      if (props.condition.type !== MAP_CONDITION_FROM_WATSON.entity) {
        return <div className="constant-value-field">existir</div>;
      }

      options = [
        MAP_CONDITION_FROM_WATSON.existir,
        MAP_CONDITION_FROM_WATSON[':'],
        MAP_CONDITION_FROM_WATSON['!='],
        MAP_CONDITION_FROM_WATSON['>'],
        MAP_CONDITION_FROM_WATSON['<']];

      width = calculeWidth(value);

      break;
    }
    case 'comparedValue': {
      /** Tenta retornar um textInput para valueCompared */
      const tried = tryReturnInputText();
      if (tried) return tried;

      let entity = props.condition.object;
      entity = allEntities.find((i) => i.name === entity);

      /** Condição que ocultam a parte comparedValue:
       *  parte logicalOperator é existir
       *  parte type é intenção
       *  parte type é entidade mas não possui valores
       */
      if (props.condition.logicalOperator === MAP_CONDITION_FROM_WATSON.existir
        || props.condition.type === MAP_CONDITION_FROM_WATSON.intent
        || !entity) {
        return <div {...isHidden} />;
      }

      options = entity.values.map((v) => v.value);
      width = calculeWidth(value);

      if (value === ' ') {
        placeholder = 'Escolha um valor';
        width = calculeWidth(placeholder);
      }
      break;
    }

    default: {
      options = [];
    }
  }

  options = options.map((o) => {
    let title = '';
    if (value && value.length > 40) title = value;
    return <SelectOption title={title} selected={value === o}>{o}</SelectOption>;
  });

  return (
    <div className={errorMessage && 'invalid-part'}>

      <Select
        value={value}
        width={width}
        placeholder={placeholder}
        onChange={onChangeConditionPartHandler}
      >
        {options}
      </Select>
      {errorMessage && <ErrorNotification {...props} />}

    </div>
  );
};

export default ConditionPart;
